/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconAnchor = createReactComponent("outline", "anchor", "IconAnchor", [["path", { "d": "M12 9v12m-8 -8a8 8 0 0 0 16 0m1 0h-2m-14 0h-2", "key": "svg-0" }], ["path", { "d": "M12 6m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }]]);

export { IconAnchor as default };
//# sourceMappingURL=IconAnchor.mjs.map
